import { apiClient } from './client';
import { API_ENDPOINTS } from './config';

export interface ProjectResponse {
  id: string;
  workspaceId: string;
  name: string;
  description?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectRequest {
  name: string;
  description?: string;
}

export const projectsApi = {
  async listByWorkspace(workspaceId: string): Promise<ProjectResponse[]> {
    return apiClient.get<ProjectResponse[]>(
      API_ENDPOINTS.PROJECTS.IN_WORKSPACE(workspaceId),
    );
  },

  async getById(projectId: string): Promise<ProjectResponse> {
    return apiClient.get<ProjectResponse>(API_ENDPOINTS.PROJECTS.BY_ID(projectId));
  },

  async createInWorkspace(
    workspaceId: string,
    data: CreateProjectRequest,
  ): Promise<ProjectResponse> {
    return apiClient.post<ProjectResponse>(
      API_ENDPOINTS.PROJECTS.IN_WORKSPACE(workspaceId),
      data,
    );
  },
};

